// packages/components/calendar/CalendarWeekdays.js
import React from "react";

/**
 * Calendar weekday header component
 *
 * @param {Object} props
 * @param {string} [props.locale='en-US'] - Locale for date formatting
 * @param {function} [props.renderWeekdays] - Custom weekday renderer
 */
const CalendarWeekdays = ({ locale = "en-US", renderWeekdays }) => {
  if (renderWeekdays) {
    return renderWeekdays({ locale });
  }

  // Generate weekday labels based on locale
  const weekdays = [];
  const date = new Date(2021, 0, 4); // Start with Monday (Jan 4, 2021 was a Monday)

  for (let i = 0; i < 7; i++) {
    const day = date.toLocaleString(locale, { weekday: "short" });
    const shortDay = day.substring(0, 1);
    const remainingChars = day.substring(1);

    weekdays.push({
      full: day,
      short: shortDay,
      remaining: remainingChars,
    });

    date.setDate(date.getDate() + 1);
  }

  return (
    <div className="grid grid-cols-7 gap-px border-b border-gray-200 bg-gray-200 text-center text-sm font-semibold leading-6  lg:flex-none">
      {weekdays.map((day, index) => (
        <div key={index} className="bg-white py-2 font-medium">
          {day.short}
          <span className="sr-only sm:not-sr-only">{day.remaining}</span>
        </div>
      ))}
    </div>
  );
};

export default CalendarWeekdays;
